<mat-paginator #paginator [length]="length" [pageIndex]="pageIndex" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"
    (page)="onPaginateChange($event)" [showFirstLastButtons]="showFirstLastButtons" aria-label="Select page">
</mat-paginator>